import { Product, SimulatedCartProduct } from '@app-types/product';

export function getCurrentPhone(cart: SimulatedCartProduct | undefined, phoneGencode: string): Product | undefined {
    const currentQuote = cart?.quotes.find((quote) => quote.current);

    if (currentQuote) {
        const phone = currentQuote.products.find((product) => product.gencode === phoneGencode);

        if (phone) {
            return phone;
        }
    }
    return undefined;
}
